import React from "react";
import PropTypes from "prop-types";
import { Query } from "react-apollo";

import ErrorBoundary from "components/Library/ErrorBoundary";
import Header from "components/Library/Header";
import TAG_STREAM_HEADER_QUERY from "./TagStreamHeader.graphql";

import styles from "./TagStreamHeader.css";

export default function TagStreamHeader({ slug }) {
  return (
    <ErrorBoundary>
      <Query query={TAG_STREAM_HEADER_QUERY} variables={{ slug }}>
        {({ loading, data }) => {
          return (
            <Header
              className={styles.root}
              text={loading ? "" : data.stream.displayName}
            />
          );
        }}
      </Query>
    </ErrorBoundary>
  );
}

TagStreamHeader.propTypes = {
  slug: PropTypes.string.isRequired,
};
